<template>
  <div class="box">

    <ul class="item list-box">
      <li @click="goIndex(index)" :class="[activeIndex===index? 'active':'']" v-for="(item,index) in navs">
        <span>{{item.text}}</span>
      </li>
    </ul>

    <div class="item del-html" v-html="delHtml">
    </div>
    <div style="text-align: center;margin-left: 255px;">
      <router-link to="/sign/add/2006">
        <div style="margin-right: 40px;" class="reg">
          Register
        </div>
      </router-link>
      <router-link to="/home_en/2006/paper/en">
        <div style="margin-left: 40px;" class="reg">
          Submit
        </div>
      </router-link>
    </div>
  </div>
</template>
<script>
  export default{
    data(){
      return {
        activeIndex: 0,
        delHtml: '',
        navs: [
          {
            text: 'Introduction',
            id: 324
          },
          {
            text: 'Organization',
            id: 325
          },
          {
            text: 'About IMS',
            id: 326
          },
          {
            text: 'Scientific Program',
            id: 327
          },
        ]
      }
    },
    props: {},
    methods: {
      goIndex(index){
        this.activeIndex = index;
        this.getData();
      },
      getData(){
        axios.request({
          url: '/medapp/api/con/info/get',
          method: 'post', // default
          data: {
            info_id: this.navs[this.activeIndex].id
          },
        }).then((response) => {
          this.delHtml = response.data.info.infoDesc;
        })
      }
    },
    computed: {},
    mounted(){
      this.getData();
    }
  }
</script>
<style scoped>
  .box {
    min-height: 774px;
    position: relative;
  }

  .item {
    display: inline-block;
    vertical-align: text-top;
  }

  .list-box {
    background-color: #f5f5fe;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
  }

  .list-box li {
    width: 228px;
    line-height: 60px;
    text-align: center;
    font-size: 14px;
    cursor: pointer;
    border-bottom: 1px solid #a0a1bd;
  }

  .list-box li.active {
    background-color: #141651;
    color: #ffffff;
  }

  .del-html {
    width: 900px;
    margin-top: 10px;
    margin-left: 255px;
  }

  .reg {
    display: inline-block;
    padding: 10px 20px;
    background: #2B2D62;
    color: #FFFFFF;
    font-size: 16px;
  }
</style>



// WEBPACK FOOTER //
// ims.vue?6a75883f